import React, { useState } from "react";
import PropTypes from "prop-types";

import DialogsContainer from "dialogs/DialogContainer";

import { DialogContext } from "contexts/dialogContext";
import { SetDialogContext } from "contexts/setDialogContext";

const DialogProvider = (props) => {
  const { children } = props;
  const [dialog, setDialog] = useState({ name: "", args: {} });

  return (
    <DialogContext value={dialog}>
      <SetDialogContext value={setDialog}>
        {children}
        <DialogsContainer />
      </SetDialogContext>
    </DialogContext>
  );
};

DialogProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DialogProvider;
